import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { isEmpty } from "lodash";
import { useMemo } from "react";
import { Dialog } from "../../components/dialogs/Dialog";
import { StandardLibraryTable } from "../../components/table/StandardLibraryTable";
import { useAppQuery } from "../../hooks/useAppQuery";
import { useLocale } from "../../providers/LocaleProvider";
import { KLAYO_COLORS } from "../../themes";

const extractorDefault = (data: any) => {
  return data;
};

export const SetttingStandardsLibaryListingModal = ({
  theme,
  onClose,
  url,
  columns,
  extractor = extractorDefault,
  open,
  name = "",
  title
}: any) => {
  const { translate } = useLocale();
  const { data: dataRes, isFetching } = useAppQuery<any>(url, { enabled: true });

  const similarJobs = useMemo(() => {
    if (!dataRes) return [];

    return extractor(dataRes) || [];
  }, [dataRes]);

  const hasLimitedAccess = useMemo(() => dataRes?.hasLimitedAccess, [dataRes]);

  return (
    <StyledSetttingStandardsLibaryListingModal
      className='klayo__import-job-from-industry-standard-dialog'
      open={open}
      theme={theme}
      onClose={onClose}
      fullWidth
      maxWidth='sm'
      actions={[
        {
          label: translate("common.cancel"),
          variant: "filled",
          onClick: onClose
        }
      ]}
    >
      <Box sx={{ padding: "0 0 1rem 0" }}>
        <Typography variant='h6'>{title}</Typography>
        <Typography variant='body1' sx={{ paddingTop: "0.5rem" }} color='text.secondary'>
          {name}
        </Typography>
      </Box>
      {!isEmpty(similarJobs) && (
        <StandardLibraryTable
          showFooterRowCount={false}
          pagination={false}
          minHeight='56px'
          theme={theme}
          translate={translate}
          showHeader={true}
          dense={true}
          paginationMode='client'
          selectable={false}
          columns={columns}
          paper={false}
          isLoading={isFetching}
          rows={similarJobs ? similarJobs : null}
          showFooter={false}
        />
      )}
      {hasLimitedAccess && (
        <Typography textAlign={"center"}>{translate("settings.contactToUpgrade")}</Typography>
      )}
    </StyledSetttingStandardsLibaryListingModal>
  );
};

const StyledSetttingStandardsLibaryListingModal = styled(Dialog)`
  &.klayo__import-job-from-industry-standard-dialog {
    h1 {
      color: ${KLAYO_COLORS.GreyGR900};
      font-family: Inter;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 32px; /* 133.333% */
      letter-spacing: -0.5px;
      margin-top: 0px;
      margin-bottom: 32px;
    }

    h2 {
      color: ${KLAYO_COLORS.GreyGR900};
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin-top: 0px;
      margin-bottom: 24px;
    }

    .main-title {
      font-weight: 700;
    }

    .MuiDialogContent-root {
      padding: 40px 40px 0px 40px;
    }

    .MuiPaper-root {
      max-width: 800px;
    }
  }
`;
